import { Button } from '@mui/material'
import { useMemo } from 'react'

import { IColumnsType } from 'pared/components/basicUi/table'

import { IPrepItemBatchStandardTableData } from './usePrepItemBatchStandardsDataSource'

interface IUsePrepItemBatchStandardsColumnsProps {
  onEditClick: (record: IPrepItemBatchStandardTableData) => void
}

const usePrepItemBatchStandardsColumns = ({
  onEditClick,
}: IUsePrepItemBatchStandardsColumnsProps): IColumnsType<IPrepItemBatchStandardTableData>[] => {
  return useMemo(
    () =>
      [
        {
          key: 'edit',
          title: 'Edit',
          minWidth: '80px',
          align: 'center',
          render: (_, record) => {
            if (!record) return null
            return (
              <Button
                variant="text"
                size="small"
                onClick={() => onEditClick(record)}
                sx={{
                  textTransform: 'none',
                  fontFamily: 'Lexend-Regular',
                  fontSize: '0.875rem',
                }}
              >
                Edit
              </Button>
            )
          },
        },
        {
          key: 'prepItem',
          title: 'Prep Item',
          minWidth: '200px',
          align: 'left',
        },
        {
          key: 'prepBatch',
          title: 'Prep Batch',
          minWidth: '150px',
          align: 'left',
        },
        {
          key: 'standardUnits',
          title: 'Standard Units',
          minWidth: '150px',
          align: 'left',
        },
        {
          key: 'standardUnitsPerBatch',
          title: 'Standard Units per Batch',
          minWidth: '200px',
          align: 'right',
          render: (value: number) => value.toLocaleString(),
        },
        {
          key: 'minimumUnit',
          title: 'Round up to',
          minWidth: '120px',
          align: 'center',
          render: (value: number) => (!value ? '-' : value),
        },
      ] as IColumnsType<IPrepItemBatchStandardTableData>[],
    [onEditClick],
  )
}

export default usePrepItemBatchStandardsColumns
